import { MantineThemeOverride } from '@mantine/core';

export type StepperTheme = NonNullable<MantineThemeOverride['components']>['Stepper'];

export const Stepper: StepperTheme = {
  // todo: define
};
